export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8195.13ff7e37.jpg";